<template>
  <div v-if="blocks.length" class="cms-extra-blocks">
    <section v-for="block in blocks" :key="block.id" :class="['cms-extra-block', block.type]">
      <h2 v-if="block.data.title">{{ block.data.title }}</h2>
      <p v-if="block.data.subtitle" class="subtitle">{{ block.data.subtitle }}</p>
      <video v-if="block.data.video" :src="block.data.video" :poster="block.data.image" controls playsinline preload="none" />
      <img v-else-if="block.data.image" :src="block.data.image" :alt="block.data.title" loading="lazy" />
      <p v-if="block.data.body" class="body">{{ block.data.body }}</p>
      <div v-if="block.data.items.length" class="items">
        <article v-for="(item, i) in block.data.items" :key="i">
          <img v-if="item.image" :src="item.image" :alt="item.title" loading="lazy" />
          <h3><a v-if="item.href" :href="item.href">{{ item.title }}</a><template v-else>{{ item.title }}</template></h3>
          <p>{{ item.text }}</p>
        </article>
      </div>
      <a v-if="block.data.buttonText && block.data.buttonUrl" class="button" :href="block.data.buttonUrl">{{ block.data.buttonText }}</a>
    </section>
  </div>
</template>
<script>
export default { name: 'CmsExtraBlocks', props: { blocks: { type: Array, default: () => [] } } }
</script>
<style scoped>
.cms-extra-blocks{background:#fff;color:#263042}.cms-extra-block{max-width:1200px;margin:auto;padding:50px 30px}.cms-extra-block h2{font-size:32px;line-height:1.5}.subtitle{color:#818b9b}.cms-extra-block img,.cms-extra-block video{display:block;max-width:100%;max-height:560px;margin:20px auto;object-fit:contain}.body,.items p{white-space:pre-wrap;line-height:1.9}.items{display:flex;flex-wrap:wrap;gap:20px}.items article{flex:1 1 220px;padding:22px;background:#f7f8fa}.button{display:inline-block;margin-top:20px;padding:12px 24px;background:#ed6b35;color:#fff;border-radius:4px}.body{font-size:18px}
</style>
